import React from "react";
import { LibraryOutletsComponent } from "../../../components";

export const LibraryOutletsPage: React.FC = () => {
  return <LibraryOutletsComponent />;
};
